module.exports = __webpack_public_path__ + "img/services_setting.a28a3dc0.svg";